<template>
  <div class="theme-box">
    <div :class="product.promotional_price? 'description-promotion' : 'description'">
      <h5 class="card-horizontal-title main-title">Tema <br> {{product.title}}</h5>
    </div>

    <div class="price-rating">
      <template v-if="product.promotional_price">
        <p class="promotional text-muted">
          <small>R$ {{product.price}}</small>
        </p>
        <p class="product-price">R$ {{product.promotional_price}}</p>
      </template>
      <template v-else>
        <p class="product-price">R$ {{product.price}}</p>
      </template>
      <star-rating
        :star-size="20"
        :rating="product.rating"
        :show-rating="false"
        :read-only="true"
        :increment="0.5"
      ></star-rating>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'theme-content',

    props: {
      product: Object,
    },
  };
</script>

<style scoped>
  .main-title {
    font-weight: 500;
    margin-bottom: 0;
  }

  .promotional {
    text-decoration: line-through;
    text-decoration-color: #ED1763;
    margin: 0;
    color: #777;
  }

  .product-price {
    color: #000000;
    font-size: 16px;
    margin-bottom: 0;
    font-weight: 400;
    font-family: Montserrat;
  }

  .theme-box {
    height: 100%;
  }

  .description-promotion {
    height: 65%;
    min-height: 153px;
  }

  .description {
    height: 73%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/ThemeContent.vue